module.exports = __webpack_public_path__ + "static/media/battles-info-screen-4.18217f43.png";